<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} ẩm thực</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} ẩm thực</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} ẩm thực</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên dịch vụ" prop="dich_vu.am_thuc.ten">
                <el-input v-model="mData.dataForm.dich_vu.am_thuc.ten" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên đơn vị" prop="don_vi_cung_cap.du_lieu_khai_bao.user_ten">
                <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_ten" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi">
                <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai">
                <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="don_vi_cung_cap.du_lieu_khai_bao.email">
                <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.email" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Website" prop="don_vi_cung_cap.du_lieu_khai_bao.website">
                <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.website" disabled
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điểm đến" prop="don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id">
                <el-select v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id"
                  :placeholder="aLang.c_select" disabled clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">

              <el-form-item label="Dịch vụ" prop="don_vi_cung_cap.am_thuc.dich_vu">
                <el-select v-model="mData.dataForm.don_vi_cung_cap.am_thuc.dich_vu" disabled clearable multiple
                  filterable>
                  <el-option v-for="item in mData.dataDefault.listOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Ngôn ngữ" prop="dich_vu.ngon_ngu" class="label-required">
                <el-select v-model="mData.dataForm.dich_vu.ngon_ngu" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col v-if="mData.viewMode == 'detail' || mData.viewMode == 'update'" md="2">
              <el-form-item label="Hiển thị" prop="dich_vu.visible" class="label-required">
                <el-select v-model="mData.dataForm.dich_vu.visible" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Giờ mở cửa" prop="dich_vu.am_thuc.gio_mo_cua">
                <el-time-select v-model="mData.dataForm.dich_vu.am_thuc.gio_mo_cua"
                  :disabled="mData.viewMode == 'detail'"
                  :picker-options="{ start: '00:00', step: '00:05', end: '23:30' }"
                  placeholder="Chọn giờ mở cửa" clearable></el-time-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Giá tiền" prop="dich_vu.am_thuc.gia_tien">
                <ElementUiMoney v-model="mData.dataForm.dich_vu.am_thuc.gia_tien" :placeholder="'Nhập giá trị ưu đãi'"
                  :disabled="mData.viewMode == 'detail'" :outlined="true" :clearable="true" @input="forceUpdateUI" />
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Loại hình ưu đãi" prop="dich_vu.loai_hinh_uu_dai">
                <el-select v-model="mData.dataForm.dich_vu.loai_hinh_uu_dai" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable
                  @change="fn_selectTypeEndow(mData.dataForm.dich_vu.loai_hinh_uu_dai)">
                  <el-option v-for="item in mData.dataDefault.listEndow" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputMoney">
              <el-form-item
                label="Giá trị ưu đãi VND"
                prop="dich_vu.gia_tri_uu_dai"
                :rules="rulesGiaTriUuDai"
              >
                <ElementUiMoney
                  :value="mData.dataForm.dich_vu.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="true"
                  @input="handleInputGiaTriUuDai"
                />
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputPercent">
              <el-form-item
                label="Giá trị ưu đãi %"
                prop="dich_vu.gia_tri_uu_dai"
                :rules="rulesGiaTriUuDaiPercent"
              >
                <el-input
                  v-model="mData.dataForm.dich_vu.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="handleInputGiaTriUuDai"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-card>
            <div slot="header">
              Link đặt dịch vụ
            </div>
            <b-row
              v-if="mData.dataForm.dich_vu && mData.dataForm.dich_vu.link_dich_vu && mData.dataForm.dich_vu.link_dich_vu.length > 0">
              <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.dich_vu.link_dich_vu" :key="item.id">
                <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'detail'" @input="forceUpdateUI"
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div slot="header">
              Link liên kết mạng xã hội
            </div>
            <b-row>
              <b-col md="4" lg="3" cols="12" v-for="(item, index) in mData.dataForm.dich_vu.link_mang_xa_hoi"
                :key="index">
                <el-form-item :label="'Link ' + (item.name ? item.name : '')"
                  :prop="`dich_vu.link_mang_xa_hoi[${index}].link`">
                  <el-input v-model="item.link" :disabled="mData.viewMode == 'detail'" @input="forceUpdateUI"
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="12">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="dich_vu.am_thuc.anh_hien_thi">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="dich_vu.am_thuc.mo_ta">
                <!-- <CknoimgComponent
                  v-model="mData.dataForm.dich_vu.am_thuc.mo_ta"
                  :prop-data-editor-disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'"
                  @blur="handleBlur('dich_vu.am_thuc.mo_ta')"
                ></CknoimgComponent> -->
                <el-input v-model="mData.dataForm.dich_vu.am_thuc.mo_ta" :disabled="mData.viewMode == 'detail'"
                  @input="forceUpdateUI" type="textarea" :rows="2" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Chi tiết" prop="dich_vu.am_thuc.chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.dich_vu.am_thuc.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'"
                  @blur="handleBlur('dich_vu.am_thuc.chi_tiet')"></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Album" prop="dich_vu.thong_tin_chung.album_anh">
                <el-upload action :auto-upload="false" drag :accept="mData.albumUploadOption.accept"
                  :on-change="handleUploadAlbum" :on-preview="handlePreviewAlbum" :on-remove="handleRemoveAlbum"
                  :file-list="mData.albumUploadOption.fileList"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'" multiple list-type="picture">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Kéo thả ảnh vào đây hoặc <em>click để upload</em></div>
                </el-upload>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-image-viewer v-if="mData.albumUploadOption.dialogVisible" :on-close="closeViewer" :url-list="mData.urlImage" />
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import ElementUiMoney from '@/component/ElementUiMoney';
import MethodService from '../../../service/MethodService';
import DataService from '@/service/DataService';
import AmThucModel from './AmThucModel';
import ShareDDATModel from '@/views/admin/ShareModel/ShareDDATModel';
import ShareDichVuModel from '@/views/admin/ShareModel/ShareDichVuModel';
import ShareDonViCungCapModel from '@/views/admin/ShareModel/ShareDonViCungCapModel';
import DichVuChoDuyetApi from '@/moduleApi/DichVuChoDuyetApi';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import DichVuApi from '@/moduleApi/DichVuApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import DichVuAmThucApi from '@/moduleApi/DichVuAmThucApi';
import DDATApi from '@/moduleApi/DDATApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import ProvinceApi from '../../../moduleApi/ProvinceApi';
import ValidService from "@/service/ValidService";
import FileApi from '@/moduleApi/FileApi';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  components: {
    CknoimgComponent,
    ElementUiMoney,
    ElImageViewer
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      imgUrl: ExtensionService.urlImg,
      mData: {
        viewMode: "create",
        moduleName: "AmThuc",
        urlImage: [],
        dataDefault: {
          listProvince: [],
          listOptions: [],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listEndow: DataService.endowList,
        },
        dataForm: {
          diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
          don_vi_cung_cap: MethodService.copyObject(ShareDonViCungCapModel.dataForm),
          dich_vu: MethodService.copyObject(ShareDichVuModel.dataForm)
        },
        fileUploadOption: MethodService.copyObject(
          AmThucModel.dataFormOther.fileUploadOption
        ),
        albumUploadOption: MethodService.copyObject(
          ShareDichVuModel.albumUploadOption
        ),
        validForm: AmThucModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
      },
      showInputMoney: false,
      showInputPercent: false,
      rulesGiaTriUuDai: [ValidService.checkGiaTriUuDaiVND(1000)],
      rulesGiaTriUuDaiPercent: [ValidService.checkGiaTriUuDaiPercent(1, 100)],
    };
  },
  async created() {
    // this.fn_initDataProvince();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      const diemDenAnToanRes = await DDATApi.list({
        filters: "nguoi_tao_id=$$user_id"
      });
      let diemDenAnToanIds = diemDenAnToanRes.result.map(id => id.id);
      let arrDiemDenAnToanIds = MethodService.findListItemDifferent(diemDenAnToanIds);
      const resDonViCungCapRes = await DonViCungCapApi.list({
        filters: "id:in:" + arrDiemDenAnToanIds.join(",")
      });
      if (resDonViCungCapRes.result.length > 0) {
        this.mData.dataForm.don_vi_cung_cap = resDonViCungCapRes.result[0];
        if (
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao &&
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.nha_hang_dich_vu &&
          typeof this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.nha_hang_dich_vu === "string"
        ) {
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.nha_hang_dich_vu = this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.nha_hang_dich_vu.split(/\r\n|\n\r|\r|\n/g);
        }

        if (
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao &&
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id
        ) {
          let resProvince = await ProvinceApi.findById(
            this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id
          );
          this.mData.dataDefault.listProvince.push(resProvince.result);
        }

        let donViCungCapRes = await DonViCungCapApi.findById(
          resDonViCungCapRes.result[0].id
        )
        if (donViCungCapRes.result) {
          this.mData.dataForm.don_vi_cung_cap = donViCungCapRes.result;
        }
        const nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Ẩm thực&hien_thi=true"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              donViCungCapRes.result.link_dich_vu &&
              donViCungCapRes.result.link_dich_vu.find(x => x.id == element.id)
            ) {
              element.link = donViCungCapRes.result.link_dich_vu.find(x => x.id == element.id).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.dich_vu.link_dich_vu = nen_tang_dich_vu.result;
      }
      this.mData.viewMode = "create";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create-admin"
    ) {
      this.mData.viewMode = "create";
      this.fn_getDataByDonViCungCapId(this.$router.currentRoute.params.id);
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
  },
  async mounted() {
    const dichVuRes = await DichVuAmThucApi.list({
      limit: 100
    });
    if (dichVuRes.result) {
      this.mData.dataDefault.listOptions = dichVuRes.result.map(item => {
        return { value: item.id, label: item.ten_vi }
      });
    }
    const tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.id, label: item.name }
      });
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm.dich_vu);
          let uu_dai = null;
          if (this.mData.dataForm.dich_vu.loai_hinh_uu_dai) {
            uu_dai = this.mData.dataForm.dich_vu.gia_tri_uu_dai + this.mData.dataForm.dich_vu.loai_hinh_uu_dai;
          }
          if (type === "create") {
            if (this.mData.currentUser.roles.includes("Officer")) {
              data.loai = this.mData.dataForm.don_vi_cung_cap.loai;
              data.diem_den_an_toan_id = this.$router.currentRoute.params.id;
              data.uu_dai = uu_dai;
              await DichVuApi.create(data);
              this.fn_go();
              this.fn_resetForm();
            } else if (this.mData.currentUser.roles.includes("SafePlace")) {
              data.loai = this.mData.dataForm.don_vi_cung_cap.loai;
              data.diem_den_an_toan_id = this.mData.dataForm.don_vi_cung_cap.id;
              data.uu_dai = uu_dai;
              try {
                let idPost = await DichVuChoDuyetApi.create(data);
                if (idPost) {
                  this.$router.push({
                    name: "Admin-" + this.mData.moduleName + "-update-history",
                    params: { id: idPost.result },
                  });
                }
              } catch (err) {
                console.info(err);
              }
              this.fn_resetForm();
            }
          }
          if (type === "update") {
            if (
              this.mData.currentUser.roles.includes('Officer') ||
              this.mData.currentUser.roles.includes('Admin')
            ) {
              data.loai = this.mData.dataForm.don_vi_cung_cap.loai;
              data.id = this.$router.currentRoute.params.id;
              data.duoc_duyet_id = this.$router.currentRoute.params.id;
              data.uu_dai = uu_dai;
              await DichVuApi.update(data);
              this.fn_go();
            } else if (
              this.mData.currentUser.roles.includes('SafePlace')
            ) {
              let dichVuChoDuyetRes = await DichVuChoDuyetApi.list({
                filters: "duoc_duyet_id=" + this.$router.currentRoute.params.id
              })
              if (dichVuChoDuyetRes.result.length == 0) {
                data.loai = this.mData.dataForm.don_vi_cung_cap.loai;
                data.diem_den_an_toan_id = this.mData.dataForm.don_vi_cung_cap.id;
                data.duoc_duyet_id = this.$router.currentRoute.params.id;
                data.uu_dai = uu_dai;
                data.duyet = {
                  duoc_duyet: null
                };
                await DichVuChoDuyetApi.createUpdate(data);
                this.fn_go();
                this.fn_resetForm();
              } else if (dichVuChoDuyetRes.result.length > 0) {
                data.loai = this.mData.dataForm.don_vi_cung_cap.loai;
                data.id = dichVuChoDuyetRes.result[0].id;
                data.duoc_duyet_id = this.$router.currentRoute.params.id;
                data.uu_dai;
                data.duyet = {
                  duoc_duyet: null
                };
                await DichVuChoDuyetApi.safePlaceUpdate(data);
                this.fn_go();
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      // Reset về đúng cấu trúc như khi khởi tạo trong data(), giữ lại
      // don_vi_cung_cap và diem_den_an_toan để template không đọc phải undefined
      this.mData.dataForm = {
        diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
        don_vi_cung_cap: MethodService.copyObject(
          ShareDonViCungCapModel.dataForm
        ),
        dich_vu: MethodService.copyObject(ShareDichVuModel.dataForm),
      };

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      const dich_vu = await DichVuApi.findById(id);
      if (dich_vu.result) {
        const resDonViCungCap = await DonViCungCapApi.list({
          filters: "id=" + dich_vu.result.diem_den_an_toan_id
        });
        this.mData.dataForm.dich_vu = dich_vu.result;
        let loaiHinhUuDai = undefined;
        let giaTriUuDai = "";
        if (dich_vu.result.uu_dai) {
          loaiHinhUuDai = dich_vu.result.uu_dai.substr(dich_vu.result.uu_dai.length - 1);
          giaTriUuDai = dich_vu.result.uu_dai.substr(0, dich_vu.result.uu_dai.length - 1);
          if (loaiHinhUuDai == "K") {
            this.showInputMoney = true;
            this.showInputPercent = false;
          } else if (loaiHinhUuDai == "%") {
            this.showInputMoney = false;
            this.showInputPercent = true;
          }
        }
        this.$set(this.mData.dataForm.dich_vu, "loai_hinh_uu_dai", loaiHinhUuDai);
        this.$set(this.mData.dataForm.dich_vu, "gia_tri_uu_dai", giaTriUuDai);
        this.mData.dataForm.don_vi_cung_cap = resDonViCungCap.result[0];
        const nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Ẩm thực&hien_thi=true"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              dich_vu.result.link_dich_vu &&
              dich_vu.result.link_dich_vu.find(x => x.id == element.id)
            ) {
              element.link = dich_vu.result.link_dich_vu.find(x => x.id == element.id).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.dich_vu.link_dich_vu = nen_tang_dich_vu.result;

        if (!this.mData.dataForm.dich_vu.link_mang_xa_hoi) {
          this.mData.dataForm.dich_vu.link_mang_xa_hoi = MethodService.copyObject(DataService.linkMangXaHoi);
        }

        if (dich_vu.result.am_thuc.anh_hien_thi) {
          let data = {
            id: dich_vu.result.am_thuc.anh_hien_thi,
            name: dich_vu.result.am_thuc.anh_hien_thi,
            url: ExtensionService.urlImg + dich_vu.result.am_thuc.anh_hien_thi
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (
          dich_vu.result.thong_tin_chung &&
          dich_vu.result.thong_tin_chung.album_anh &&
          dich_vu.result.thong_tin_chung.album_anh.length > 0
        ) {
          let arrFileIds = [];
          dich_vu.result.thong_tin_chung.album_anh.forEach(x => {
            arrFileIds.push(x.anh_id);
          })
          const fileList = await FileApi.list({
            filters: "id:in:" + arrFileIds.join(",")
          })
          dich_vu.result.thong_tin_chung.album_anh.forEach(e => {
            let fileName = fileList.result.find(y => y.id == e.anh_id)
            let data = {
              id: e.anh_id,
              name: fileName.name,
              url: ExtensionService.urlImg + e.anh_id
            };
            this.mData.albumUploadOption.fileList.push(data);
            this.mData.urlImage.push(data.url);
          })
        } else {
          this.mData.dataForm.dich_vu.thong_tin_chung = {
            album_anh: []
          };
        }
      }
    },

    async fn_getDataByDonViCungCapId(id) {
      let donViCungCapRes = await DonViCungCapApi.findById(id);
      if (donViCungCapRes.result) {
        this.mData.dataForm.don_vi_cung_cap = donViCungCapRes.result;
        const nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Ẩm thực&hien_thi=true"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              donViCungCapRes.result.link_dich_vu &&
              donViCungCapRes.result.link_dich_vu.find(x => x.id == element.id)
            ) {
              element.link = donViCungCapRes.result.link_dich_vu.find(x => x.id == element.id).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.dich_vu.link_dich_vu = nen_tang_dich_vu.result;
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },
    fn_selectTypeEndow(e) {
      if (e == "K") {
        this.showInputMoney = true;
        this.showInputPercent = false;
      } else if (e == "%") {
        this.showInputMoney = false;
        this.showInputPercent = true;
      } else {
        this.showInputMoney = false;
        this.showInputPercent = false;
      }
      this.$set(this.mData.dataForm.dich_vu, "gia_tri_uu_dai", "");
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("dich_vu.gia_tri_uu_dai");
        }
      });
    },
    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.dich_vu.am_thuc.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "AmThuc")
        .then(res => {
          this.mData.dataForm.dich_vu.am_thuc.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("dich_vu.am_thuc.anh_hien_thi");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    //Album
    handleUploadAlbum(file, fileList) {
      if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
        toastr.info("Vui lòng tải lên ảnh có định dạng .jpeg, .jpg hoặc .png");
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        return
      }
      ExtensionService.upload(file, "Album")
        .then((res) => {
          this.mData.dataForm.dich_vu.thong_tin_chung.album_anh.push(
            {
              anh_id: res.result
            }
          );
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.albumUploadOption.fileList = fileList;
          this.mData.albumUploadOption.fileList.forEach((item) => {
            this.mData.urlImage.push(item.url);
          });
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    handleRemoveAlbum(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.dich_vu.thong_tin_chung.album_anh = data;
    },
    handlePreviewAlbum() {
      this.mData.albumUploadOption.dialogVisible = true;
    },
    getListImage(arrFileIds) {
      arrFileIds.forEach((item) => {
        let url = this.imgUrl + item.anh_id.id;
        this.mData.urlImage.push(url);
      });
    },
    closeViewer() {
      this.mData.albumUploadOption.dialogVisible = false;
    },
    handleInputGiaTriUuDai(val) {
      this.$set(this.mData.dataForm.dich_vu, "gia_tri_uu_dai", val);
      if (this.$refs["myForm"]) {
        this.$refs["myForm"].clearValidate("dich_vu.gia_tri_uu_dai");
      }
      this.forceUpdateUI();
    },
  }
}
</script>
